import cx from 'clsx';

import { InputOverrideClassNames } from '../textinput';
import { InputStyleProps } from '../types';

import classes from './Select.module.css';

export const SelectOverrideClassNames = (props: InputStyleProps) => {
  const { size } = props;

  return {
    ...InputOverrideClassNames(props),
    dropdown: classes.dropdown,
    options: classes.options,
    option: cx(classes.option, {
      [classes.optionSmall]: ['xs', 'sm', 'md'].includes(size as string),
      [classes.optionBig]: ['lg', 'xl'].includes(size as string)
    }),
    empty: classes.empty
  };
};
